import * as yup from 'yup';

export const individual_bank_custodian_validation_schema = yup.object().shape({

    custodianName: yup.string()
        .when('isHaveCustdoian', {
            is: '1',
            then: schema =>
                schema
                    .required('custodian_name_is_required')
                    .max(100, 'max_100_character'),
            otherwise: schema => schema.notRequired(),
        }),

    accountAddress: yup.string()
        .when('isHaveCustdoian', {
            is: '1',
            then: schema =>
                schema
                    .required('custodian_name_is_required')
                    .max(100, 'max_100_character'),
            otherwise: schema => schema.notRequired(),
        }),

    accountName: yup.string()
        .when('isHaveCustdoian', {
            is: '1',
            then: schema =>
                schema
                    .required('account_name_is_required')
                    .max(100, 'max_100_character'),
            otherwise: schema => schema.notRequired(),
        }),
        
    accountNumber: yup.string()
        .when('isHaveCustdoian', {
            is: '1',
            then: schema =>
                schema
                    .required('account_no_is_required')
                    .max(20, 'max_20_character'),
            otherwise: schema => schema.notRequired(),
        }),

    //   custodianName: yup
    //     .string()
    //     .required('custodian_name_is_required'),

    //   accountAddress: yup
    //     .string()
    //     .required('custodian_address_is_required'),

    //   accountName: yup
    //     .string()
    //     .required('account_name_is_required'),

    //   accountNumber: yup
    //     .string()
    //     .required('account_no_is_required'),

});